
import React from 'react';
import { BounceInDownButton } from '../../animation/bounceIn';


const IpBlocked = () => {
    return (
        <section className="PageNotFoundSec">
            <div className="container">
                <div className="row align-items-center justify-content-center min-vh-100 py-4">

                    <div className="col-12">
                        <div className="PageNotFoundCnt">
                            <img src={require('../../assets/images/ipblock.png')} alt='ipblock' />
                            <BounceInDownButton>
                                <h6>Your IP has been blocked !!!</h6>
                            </BounceInDownButton>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default IpBlocked;